export const SUPPORTED_LOCALES = ['en', 'hi', 'kn', 'te', 'mr', 'bn'] as const;
export const DEFAULT_LOCALE = 'en' as const;
